export default "__VITE_ASSET__BxBoBQAC__"